import type { EffectNumber } from '@unifyapps/defs/types/effectObject';
import { getConditionalPropertyValue } from '../../../../utils/conditionalValues';

// Numeric effect axes (offset, blur radius, spread) accept either a literal
// number, a `{{expression}}` string (when the panel is in JS mode and the
// no-code engine hasn't evaluated yet), or a conditional-binding object.
// Resolve to a finite number before arithmetic — anything else NaN-poisons
// `+`/`*` and corrupts the shadow string into `NaNpx ...` (web) or breaks
// `BoxShadowValue` offsets (native).
export const resolveEffectNumber = (value: EffectNumber | undefined): number => {
  // Short-circuit string before `getConditionalPropertyValue` — its generic
  // expects `ValueOrCondition<number>` (number | object), not a string.
  if (typeof value === 'string') {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : 0;
  }
  const resolved = getConditionalPropertyValue<number>({ value });
  if (typeof resolved === 'number' && Number.isFinite(resolved)) return resolved;
  if (typeof resolved === 'string') {
    const numeric = Number(resolved);
    return Number.isFinite(numeric) ? numeric : 0;
  }
  return 0;
};
